module.exports = __webpack_public_path__ + "static/media/kaidoMenu092023-2.01535f81.pdf";